module.exports = __webpack_public_path__ + "img/hotel-baia-pedras.31998b88.jpg";